<template>
  <div class="container">
    <h2>Dashboard</h2>
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Total</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="survey in surveys" :key="survey.id">
          <td>{{ survey.id }}</td>
          <td>{{ survey.name }}</td>
          <td>{{ survey.total }}</td>
          <td>
            <div class="actions">
              <router-link
                :to="{ name: 'survey', params: { id: survey.id } }"
                title="New Survey"
              >
                <vue-fontawesome icon="plus-square" size="2" color="#A0C22B"></vue-fontawesome>
              </router-link>&nbsp;
              <a @click.prevent="removeSurvey(survey)">
                <vue-fontawesome icon="trash" size="2" color="#f00"></vue-fontawesome>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { surveys as surveysDb, answers as answersDb } from '@/database'

import '@/assets/css/global.scss';

export default {
  name: 'Dashboard',
  components: {
  },

  data() {
    return {
      syncs: [],
      surveys: [],
      online: navigator.onLine,
    }
  },

  methods: {
    removeSurvey({ id, name }) {
      if( confirm(`Are you sure you want to remove ${name} ?`) ){
        surveysDb.removeItem(id).then(() => {
          console.log('survey successfully removed');
          this.$router.go();
        }).catch((error) => {
          console.error(error);
        })
      }
    },

    getSurveys() {
      let surveys = [];

      (async () => {
        await surveysDb.keys().then(keys => {
          for ( const key in keys ) {
            surveysDb.getItem(keys[key]).then(value => {
              surveys.push({
                id: value.id,
                name: value.name,
                total: 0
              })
            })
          }
        })
        await answersDb.keys().then(keys => {
          for ( const key in keys ) {
            answersDb.getItem(keys[key]).then(value => {
              const { survey } = value.pop();
              const index = surveys.findIndex(s => s.id == survey);
              if ( index >= 0 ){
                surveys[index].total++;
              }
            })
          }
        })
      })();

      this.surveys = surveys;
    }
  },

  created() {
    this.getSurveys();
  },
}
</script>

<style lang="scss" scoped>
  h2 {
    margin-bottom: 10px;
  }

  a {
    cursor: pointer;
  }

  table {
    width: 100%;
    border-collapse: collapse;

    tr {
       height: 30px;
    }

    th, td {
      padding: 0;
      border: 1px solid;
    }

    td {
      text-align: center;
    }
  }

  .actions {
    display: inline-flex;
    justify-content: space-between;
    width: 60px;
  }
</style>